import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setData } from '../../redux/menuSlice';

const normalize = (path) => ('/' + String(path || '').split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '')).toLowerCase();
const match = (path, base) => path === base || path.startsWith(base + '/');

export default function RoutePermissionGuard({ children }) {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  let entries;
  try {
    const raw = localStorage.getItem('adminMenu');
    const parsed = raw ? JSON.parse(raw) : null;
    entries = Array.isArray(parsed) ? parsed.flatMap(parent => [parent, ...(Array.isArray(parent.children) ? parent.children : [])]) : [];
  } catch { entries = []; }
  const path = normalize(pathname);
  const matched = entries.filter(item => item?.routePath && match(path, normalize(item.routePath)))
    .sort((a, b) => normalize(b.routePath).length - normalize(a.routePath).length)[0];
  const allowed = Boolean(matched) && normalize(matched.routePath) !== '/logout';
  useEffect(() => {
    dispatch(setData(allowed && Array.isArray(matched.permissions) ? matched.permissions : []));
  }, [dispatch, allowed, pathname]);
  if (!allowed) return <div role="alert" style={{padding: '3rem', textAlign:'center'}}><h2>403 - Access Denied</h2><p>ທ່ານບໍ່ມີສິດເຂົ້າໃຊ້ໜ້ານີ້</p></div>;
  return children;
}
